import { render, staticRenderFns } from "./chooseSeal.vue?vue&type=template&id=8124deae&scoped=true&"
import script from "./chooseSeal.vue?vue&type=script&lang=js&"
export * from "./chooseSeal.vue?vue&type=script&lang=js&"
import style0 from "./chooseSeal.vue?vue&type=style&index=0&id=8124deae&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8124deae",
  null
  
)

export default component.exports